import { Button } from '@simplywallst/ui-core/next';
import DiscoverOutline from '@simplywallst/ui-core/icons/DiscoverOutline';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import type { Editor } from '@tiptap/core';

import { NARRATIVE_CONTENT_SUGGESTIONS } from '@/pages/Narrative/utils/template';
import { NarrativeEditorSuggestionItem } from './components/NarrativeEditorSuggestionItem';

type Props = {
  editor: Editor;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
};

export const NarrativeEditorSuggestions = ({
  editor,
  isOpen,
  onClose,
  onOpen,
}: Props) => {
  const insertContent = (html: string) => {
    if (editor.isActive('bulletList')) {
      editor
        .chain()
        .focus()
        .enter()
        .liftListItem('listItem')
        .toggleBulletList()
        .run();
    }

    editor.chain().focus().insertContent(html).enter().focus().run();

    onClose();
  };

  return (
    <>
      <div className="grid items-center">
        <Button
          variant="subtle"
          size="medium"
          onClick={() => (isOpen ? onClose() : onOpen())}
        >
          {isOpen ? (
            <>
              <CrossSolid />
              Close ideas
            </>
          ) : (
            <>
              <DiscoverOutline />
              Get ideas
            </>
          )}
        </Button>
      </div>
      {isOpen && (
        <div
          className="absolute inset-x-0 bottom-[57px] bg-gradient-to-b from-p-grey-100/0
        via-75% to-p-grey-100 py-x2"
        >
          <div className="grid grid-cols-2 grid-rows-[auto_auto] items-center gap-x1 sm:grid-cols-[repeat(auto-fit,minmax(0,1fr))] sm:grid-rows-[auto]">
            {NARRATIVE_CONTENT_SUGGESTIONS.map(({ title, subtitle, html }) => (
              <NarrativeEditorSuggestionItem
                key={title}
                title={title}
                subtitle={subtitle}
                html={html}
                onClick={insertContent}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
